export enum PaymentStatusEnum {
  SUCCESSFUL = 0,
  PENDING = 1,
  ERROR = 2,
  CANCELLED = 3
}
